import Layout from './Layout.js';

  export default function Document() {
  return (
    <div className="layout ">
      <Layout/>
    </div>
  );
}